/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Attachment
 */
export interface Attachment {
  /**
   *
   * @type {string}
   * @memberof Attachment
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof Attachment
   */
  bytes: string;
  /**
   *
   * @type {string}
   * @memberof Attachment
   */
  extension?: string | null;
  /**
   *
   * @type {string}
   * @memberof Attachment
   */
  contentType: string;
  /**
   *
   * @type {string}
   * @memberof Attachment
   */
  docRef?: string | null;
  /**
   *
   * @type {string}
   * @memberof Attachment
   */
  fileName: string;
}

/**
 * Check if a given object implements the Attachment interface.
 */
export function instanceOfAttachment(value: object): value is Attachment {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("bytes" in value) || value["bytes"] === undefined) return false;
  if (!("contentType" in value) || value["contentType"] === undefined)
    return false;
  if (!("fileName" in value) || value["fileName"] === undefined) return false;
  return true;
}

export function AttachmentFromJSON(json: any): Attachment {
  return AttachmentFromJSONTyped(json, false);
}

export function AttachmentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Attachment {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    bytes: json["bytes"],
    extension: json["extension"] == null ? undefined : json["extension"],
    contentType: json["contentType"],
    docRef: json["docRef"] == null ? undefined : json["docRef"],
    fileName: json["fileName"],
  };
}

export function AttachmentToJSON(json: any): Attachment {
  return AttachmentToJSONTyped(json, false);
}

export function AttachmentToJSONTyped(
  value?: Attachment | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    bytes: value["bytes"],
    extension: value["extension"],
    contentType: value["contentType"],
    docRef: value["docRef"],
    fileName: value["fileName"],
  };
}
